import React from "react";

export const MenuToggle = ({ isOpen, toggle }) => {
  return (
    <div
      className="flex flex-col justify-center items-center w-[30px] h-[30px] cursor-pointer group"
      onClick={toggle}
    >
      <span
        className={`block w-[26px] h-[3px] bg-[#739D00] rounded-sm transition-all duration-300 ease-out group-hover:bg-[#739d00a8] mb-1.5 ${
          isOpen ? "rotate-45 translate-y-[9px] translate-x-[1px]" : ""
        }`}
      />
      <span
        className={`block w-[26px] h-[3px] bg-[#739D00] rounded-sm transition-all duration-300 ease-out group-hover:bg-[#739d00a8] mb-1.5 ${
          isOpen ? "opacity-0" : ""
        }`}
      />
      <span
        className={`block w-[26px] h-[3px] bg-[#739D00] rounded-sm transition-all duration-300 ease-out group-hover:bg-[#739d00a8] ${
          isOpen ? "-rotate-45 -translate-y-[9px] translate-x-[1px]" : ""
        }`}
      />
    </div>
  );
};
